module.exports = __webpack_public_path__ + "static/media/03.d996146a.png";